import type { FuseOptionKey } from 'fuse.js';

export interface SearchablePage {
  title: string;
  path: string;
  /** The menu the page sits in, shown as the row's sub-line. */
  section?: string;
  /** One pre-joined string rather than an array, so fuse.js scores it as a single field. */
  keywords: string;
  adminOnly?: boolean;
  /** useUserMenuItems hides these from child accounts. */
  childHidden?: boolean;
}

// Module-level: useFuzzySearch keys its Fuse memo on this reference.
export const PageSearchFields: Array<FuseOptionKey<SearchablePage>> = ['title', 'keywords'];

/**
 * Titles are re-declared rather than read from the nav hooks, whose labels are JSX — they can drift.
 * Order matters: the first entries a user may see double as the quick actions.
 */
export const SearchablePages: Array<SearchablePage> = [
  {
    title: 'Account',
    path: '/admin/account',
    keywords: 'account profile settings email password api token',
  },
  {
    title: 'Billing',
    path: '/admin/account/billing',
    section: 'Account',
    keywords: 'billing invoices payment subscription credits costs',
    childHidden: true,
  },
  {
    title: 'Tracker Management',
    path: '/admin/trackers',
    section: 'Trackers',
    keywords: 'trackers devices gps management transponders',
  },
  {
    title: 'Tracking Maps',
    path: '/admin/events',
    keywords: 'events races maps tracking list',
  },
  {
    title: 'Message Templates',
    path: '/admin/message-templates',
    section: 'Trackers',
    keywords: 'messages templates sms notifications',
  },
  {
    title: 'SIM Cards',
    path: '/admin/sim-cards',
    section: 'Trackers',
    keywords: 'sim cards data management mobile',
  },
  {
    title: 'Users',
    path: '/admin/users',
    section: 'Admin',
    keywords: 'users accounts customers management',
    adminOnly: true,
  },
  {
    title: 'Manage Events',
    path: '/admin/events/manage',
    section: 'Admin',
    keywords: 'events management overview all',
    adminOnly: true,
  },
  {
    title: 'Billing Report',
    path: '/admin/billing/report',
    section: 'Admin',
    keywords: 'billing report revenue invoices',
    adminOnly: true,
  },
  {
    title: 'User Help Requests',
    path: '/admin/user-feedback',
    section: 'Admin',
    keywords: 'help requests feedback support tickets',
    adminOnly: true,
  },
  {
    title: 'User Credits',
    path: '/admin/user-credits',
    section: 'Admin',
    keywords: 'credits vouchers balance',
    adminOnly: true,
  },
  {
    title: 'Starter Tags',
    path: '/admin/starter-tags',
    section: 'Admin',
    keywords: 'starter tags participants labels',
    adminOnly: true,
  },
  {
    title: 'Log Level',
    path: '/admin/log-level',
    section: 'Admin',
    keywords: 'log level logging debug',
    adminOnly: true,
  },
];
